// hooks/useTeammateRow.js - Teammate Row Hook
import { useMemo } from 'react';

const useTeammateRow = ({ product, deleteThisProductId }) => {
  const lightboxOptions = useMemo(
    () => ({
      buttons: {
        showAutoplayButton: false,
        showCloseButton: true,
        showDownloadButton: false,
        showFullscreenButton: false,
        showNextButton: false,
        showPrevButton: false,
        showThumbnailsButton: false,
      },
      thumbnails: {
        showThumbnails: false,
      },
    }),
    [],
  );

  const productUrl = useMemo(() => {
    return `/products/${product?.products?.album_id}/${product['products']['accounting_name_product']?.split(' ')?.join('-')}?weight=${product['products'].weight}&barcode=${product['products'].accounting_barcode}`;
  }, [product]);

  const isDeleting = deleteThisProductId === product['customers_basket_id'];

  return {
    lightboxOptions,
    productUrl,
    isDeleting,
  };
};

export default useTeammateRow;
